<template>
    <v-list two-line
            subheader>
        <v-subheader inset>FAQ</v-subheader>
        <v-list-tile v-for="item in items"
                     :key="item.title"
                     avatar>
            <v-list-tile-avatar>
                <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
            </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar>
            <v-btn flat
                   outline
                   class="teal--text darken-2">Kangaruu</v-btn>
            <v-list-tile-content>
                <v-list-tile-title>Home</v-list-tile-title>
                <v-list-tile-sub-title>Return to Inbox</v-list-tile-sub-title>
            </v-list-tile-content>
        </v-list-tile>

    </v-list>
</template>

<script>
export default {
  data () {
    return {
      items: [
        { icon: 'add', iconClass: 'blue', title: 'Add', subtitle: 'Add additional items.' },
        { icon: 'check', iconClass: 'teal', title: 'OK', subtitle: 'Add item and move to next.' },
        { icon: 'access_time', iconClass: 'orange', title: 'Get Distance', subtitle: 'Calculate distane and generate delivery date.' }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Help.vue